import { Modal, Tab, Tabs } from "@mui/material";
import styles from "./styles.module.scss";
import classNames from "classnames";
import { useEffect, useState } from "react";
import { DEFAULT_SETTLEMENT_TAB, MANUAL_SETTLEMENT_TAB } from "./constants";
import DefaultSettlement from "./DefaultSettlement/index";
import ManualSettlement from "./ManualSettlement/index";
import { useTranslation } from "react-i18next";
import {
  EContractType,
  IContractDetailsResponseData,
} from "../../../../../setup/api/services/contract/models";
import AdvancedSettlementModal from "../AdvancedSettlementModal";

interface ISettlementModal {
  open: boolean;
  handleClose: () => void;
  propose?: boolean;
  contract: IContractDetailsResponseData;
}

const SettlementModal = ({
  open,
  handleClose,
  propose,
  contract,
}: ISettlementModal) => {
  const [tabType, setTabType] = useState("default");
  const { t } = useTranslation();

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setTabType(newValue);
  };

  const isAdvancedSettlement =
    contract?.type !== EContractType.QUICK_TRANSACTION;

  useEffect(() => {
    const cashOutAmountListExists = contract?.cashOutAmountList?.length;

    if (cashOutAmountListExists) {
      setTabType("manual");
    }
  }, [contract?.cashOutAmountList?.length]);

  if (isAdvancedSettlement) {
    return (
      <AdvancedSettlementModal
        open={open}
        handleClose={handleClose}
        propose={propose}
      />
    );
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      className={styles.modalContainer}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <div className={classNames(styles["card"], styles["modal_body"])}>
        <div className={styles["modal_header"]}>
          <h1 className={styles["h1"]}>
            {propose ? t("lbl_resolve_dispute") : t("global_status_settlement")}
          </h1>
          <img
            src="/assets/images/svg/remove.svg"
            alt=""
            className={styles["close_icon"]}
            onClick={handleClose}
          />
        </div>
        <>
          <div className={styles["tab_container"]}>
            <Tabs
              style={{ alignItems: "center" }}
              className={styles.tab_wrapper}
              value={tabType}
              onChange={handleTabChange}
              TabIndicatorProps={{
                style: { display: "none" },
              }}>
              <Tab
                value="default"
                label={DEFAULT_SETTLEMENT_TAB}
                className={classNames(
                  styles.tab,
                  tabType === "default" && styles.tab_selected
                )}
              />
              <Tab
                value="manual"
                label={MANUAL_SETTLEMENT_TAB}
                className={classNames(
                  styles.tab,
                  tabType === "manual" && styles.tab_selected
                )}
              />
            </Tabs>
          </div>
          {tabType === "default" ? (
            <DefaultSettlement propose={propose} onSuccess={handleClose} />
          ) : (
            <ManualSettlement propose={propose} onSuccess={handleClose} />
          )}
        </>
      </div>
    </Modal>
  );
};

export default SettlementModal;
